export enum FulfillmentStatus {
  Unfulfilled = 'Unfulfilled',
  Fulfilled = 'Fulfilled',
}
